import {forwardRef} from 'react'
import {chakra, type LinkProps} from '@chakra-ui/react'
import {Link as InertiaLink, type InertiaLinkProps} from '@inertiajs/react'

const StyledLink = chakra(InertiaLink, {
  base: {color: 'blue.500', _hover: {textDecoration: 'underline'}},
})

export default forwardRef<HTMLAnchorElement, LinkProps & InertiaLinkProps>(
  function Link(props, ref) {
    return <StyledLink {...props} ref={ref} />
  },
)
